import useMounted from '@jswork/use-mounted';
import { useEffect, useState } from 'react';

const KEY_MAPPING = {
  courseCatalogueResponses: 'children',
  name: 'label',
  title: 'label',
  uuid: 'value',
};

const getIds = inItems => {
  const res = [];
  nx.deepEach(inItems, (key, value) => {
    if (key === 'value') {
      res.push(value);
    }
  });
  return res;
};

export default () => {
  const isMounted = useMounted();
  const [units, setUnits] = useState([]);
  const courseUuid = nx.get(nx.$root, 'catalog.current.uuid');

  useEffect(() => {
    const { subject } = alo7Nav;
    if (!courseUuid) return;
    nx.$api.business_for_content_repository_list({ subject, courseUuid }).then(res => {
      if (!isMounted) return null;
      const _units = nx.keyMap(res.courseCatalogueResponses, KEY_MAPPING);
      setUnits(_units);
    });
  }, [isMounted, courseUuid]);

  return { units, setUnits, ids: getIds(units) };
};
